import { Square, Circle, Minus } from 'lucide-react';
import { useCurrentTarget } from './useCurrentTarget';
import { useProjectStore } from '../../../state/projectStore';
import { EmptyState } from '../../ui/EmptyState';
import { t } from '../../../i18n';
import type { ShapeElement } from '@fotoboek/domain';

function makeShape(shape: ShapeElement['shape']): ShapeElement {
  return {
    id: crypto.randomUUID(),
    type: 'shape',
    shape,
    x: 40,
    y: 40,
    width: shape === 'line' ? 100 : 80,
    height: shape === 'line' ? 1 : 80,
    rotation: 0,
    opacity: 1,
    zIndex: 0,
    locked: false,
    hidden: false,
    fill: shape === 'line' ? null : '#e8e4de',
    stroke: shape === 'line' ? '#1a1a1a' : null,
    strokeWidthMm: shape === 'line' ? 0.5 : 0,
    cornerRadiusMm: 0,
  };
}

export function ShapesTab() {
  const target = useCurrentTarget();
  const addElement = useProjectStore((s) => s.addElement);

  if (!target) {
    return (
      <div className="left-panel-tab-body">
        <EmptyState title="Selecteer eerst een pagina." />
      </div>
    );
  }

  return (
    <div className="left-panel-tab-body">
      <button
        className="left-panel-action-btn"
        onClick={() => addElement(target, makeShape('rectangle'))}
      >
        <Square size={16} />
        {t('editor.shapes.rectangle')}
      </button>
      <button
        className="left-panel-action-btn"
        onClick={() => addElement(target, makeShape('ellipse'))}
      >
        <Circle size={16} />
        {t('editor.shapes.ellipse')}
      </button>
      <button
        className="left-panel-action-btn"
        onClick={() => addElement(target, makeShape('line'))}
      >
        <Minus size={16} />
        {t('editor.shapes.line')}
      </button>
    </div>
  );
}
